import React from "react";
import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/New8.jpg";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

const Blog9 = () => {
  const navigate = useNavigate();
  return (
    <div className="about-us-page">
      <Hero title="Blogs" backgroundImage={HeroImage} />
      <div className="primary-background-container-content">
        <div className="privacy-container">
          <h3>Investing – Keep It Simple, Stupid</h3>
          <p>
            The purpose of investing is not to outperform the market or follow
            fashionable strategies, but to ensure that financial resources
            support real objectives: financial independence, flexibility around
            work, protection against unforeseen events, and a sustainable
            retirement that does not depend on continued clinical income. Our
            investment philosophy is therefore tightly integrated with life
            planning and cash-flow modelling, rather than being treated as a
            standalone activity.
          </p>
          <p>
            <strong>Core Investment Beliefs</strong>
          </p>
          <p>
            You use evidence-based medicine, our approach is evidence-based
            investing built on data collected from decades of market history.
            While markets and products evolve, these underlying principles have
            remained remarkably consistent.
          </p>
          <p>
            <strong>Asset Allocation as the Primary Driver of Outcomes</strong>
          </p>
          <p>
            The most important decision in investing is how assets are allocated
            between growth assets, such as equities, and defensive assets, such
            as high-quality bonds. Equities have historically delivered the
            strongest long-term returns, but an all-equity portfolio introduces
            levels of volatility that many doctors and surgeons find
            uncomfortable, particularly when approaching retirement and your
            financial plan involves income withdrawals or a reduction in
            clinical workload.
          </p>
          <p>
            Equally important, taking maximum risk is often unnecessary. Many
            clinicians accumulate substantial capital over relatively short but
            intense earning periods. The objective is not to take the highest
            possible risk, but to take only the level of risk required to meet
            clearly defined goals.
          </p>
          <p>
            {" "}
            <strong>The Impact of Costs</strong>
          </p>
          <p>
            Costs are one of the few variables investors can control. As the
            late Jack Bogle, founder of The Vanguard Group, observed: “You get
            what you don’t pay for.”
          </p>
          <p>
            Every pound lost to unnecessary fees is a pound that cannot compound
            for future use. Over a multi-decade investment horizon common for
            doctors who may start to invest in their 30s through to their 80s,
            cost control has a significant effect on outcomes.
          </p>
          <p>
            {" "}
            <strong>Diversification as Risk Management</strong>
          </p>
          <p>
            Diversification is not about maximising returns in favourable
            markets but about reducing the risk of permanent capital loss. We
            diversify across asset classes, global markets, and different
            investment styles. We avoid a home-country bias, as concentrating
            wealth in a single economy can increase risk without improving
            expected returns.
          </p>
          <p>
            Some say diversification means always being disappointed by
            something in the portfolio. In practice, this may be true. At any
            given time, some holdings will underperform. Over the long term,
            however, diversification has historically produced more stable and
            predictable outcomes.
          </p>
          <p>
            {" "}
            <strong>Market Efficiency and the Limits of Prediction</strong>
          </p>
          <p>
            Consistently beating global markets by selecting the “right” funds,
            countries, or sectors in advance is exceptionally difficult.
            Similarly, timing entry and exit points reliably has not proven
            achievable for most investors, including professionals.
          </p>
          <p>
            For clinicians whose time and energy are better spent on patient
            care or running a private practice, we believe a disciplined,
            rules-based approach is more appropriate than attempting to forecast
            short-term market movements.
          </p>
          <p>
            {" "}
            <strong>The Link Between Risk and Return</strong>
          </p>
          <p>
            Higher returns require higher risk, there are no shortcuts. Our role
            is to ensure that clients accept no more risk than is necessary to
            meet their objectives, and that this risk is aligned with their
            capacity to tolerate market fluctuations, particularly in retirement
            and income is being drawn from investments.
          </p>
          <p>
            {" "}
            <strong>The Importance of Rebalancing</strong>
          </p>
          <p>
            Over time, growth assets tend to outperform defensive assets.
            Without periodic rebalancing, portfolios can drift into higher-risk
            positions than originally agreed. Rebalancing is therefore essential
            to maintain alignment with a client’s risk profile and financial
            plan, rather than allowing market movements to dictate risk levels.
          </p>
          <p>
            {" "}
            <strong>Risk Management Across the Market Cycle</strong>
          </p>
          <p>
            Not all assets behave well during market stress. We exclude certain
            asset types, such as high-yield bonds, because their risk-return
            characteristics deteriorate significantly during turbulent periods.
            For doctors approaching retirement or reducing private practice
            commitments, limiting downside risk becomes increasingly important.
          </p>
          <p>
            <strong>Managing Concentration Risk in Equity Markets</strong>
          </p>
          <p>
            We also make considered adjustments within equity allocations,
            including exposure to emerging markets and smaller, value-oriented
            companies. These adjustments have historically helped reduce the
            risk of over-reliance on a narrow group of large companies,
            particularly during periods of market excess. This is especially
            relevant for clinicians who may retire just as markets enter a
            prolonged downturn.
          </p>
          <p>
            {" "}
            <strong>A Long-Term Perspective</strong>
          </p>
          <p>
            Our investment philosophy is informed by close to a century of
            global market data. We invest with multi-decade horizons in mind,
            particularly when advising doctors whose retirement planning often
            spans long careers.
          </p>
          <p>
            {" "}
            <strong>Investing in Practice</strong>
          </p>
          <p>
            Understanding the client, not the market is always our first step.
            For doctors and surgeons, this includes current and future NHS
            income, private practice cash flows, pension structures, tax
            considerations, lifestyle goals and “the here and now”.
          </p>
          <p>
            From there, we determine an appropriate balance between growth
            assets, which aim to deliver returns above inflation, and defensive
            assets, which help reduce volatility and limit losses during market
            downturns. The objective is to achieve sufficient growth while
            maintaining a level of risk that allows clients to remain invested
            through challenging periods.
          </p>
          <p>
            <strong>A Deliberately Simple Approach</strong>
          </p>
          <p>
            Investment history is filled with examples of complex strategies
            that appeared robust until markets turned against them. The global
            financial crisis of 2007–2008 is a reminder that complexity does not
            equal resilience.
          </p>
          <p>
            We favour transparent, evidence-based investing, built to support
            long-term planning rather than short-term narratives. This is the
            same approach we use for our own investments.
          </p>
          <p>
            At Foundations Financial Planning, investing is an important
            component of the financial plans we build, but it is a small part of
            the service we provide. For doctors and surgeons, particularly those
            with substantial private practice income, our aim is not investment
            performance, but the ability to meet life objectives with confidence
            and clarity.
          </p>
          <p>
            The value of investments and the income they produce can fall as
            well as rise. You may get back less than you invested.{" "}
          </p>
        </div>
        <Button
          text="CONTACT US"
          variant="primary"
          onClick={() => navigate("/contact")}
        />
      </div>
    </div>
  );
};

export default Blog9;
